import { attr,  Model, fk,  } from "redux-orm";
import { AppAction } from 'src';
import { IORMModels, ISession } from 'src/Config/ConfigureOrm';
// import { CREATE_PERSON, UPDATE_PERSON } from './Person.Actions';
import User from '../User/User';
import { SET_IS_LOADING } from './PortalLoadinState.Actions';


export interface IPortalLoadingState {
    id: number;
  USER: boolean;
  ACTIVITY: boolean;
  ACTIVITYCATEGORY: boolean;
  ACTIVITYTHEME: boolean;
  PORTALSEARCH: boolean;
}

export default class PortalLoadingState extends Model<IPortalLoadingState> implements IPortalLoadingState {
    public static modelName = 'PortalLoadingState'
    public static fields = {
        id: attr({})

    }

    public static reducer(action: AppAction<any>, loadingSate: typeof Model, session: ISession<IORMModels>) {
        switch (action.type) {
            case SET_IS_LOADING:
                loadingSate.upsert<IPortalLoadingState>({id:0, [action.payload.stateKey]: action.payload.isLoading})    
                break;
               

        }
    }
    public id: number;
    public USER: boolean;
    public ACTIVITY: boolean;
    public ACTIVITYCATEGORY: boolean;
    public ACTIVITYTHEME: boolean;
    public PORTALSEARCH: boolean;

    
}


// WEBPACK FOOTER //
// ./src/Entities/PortalLoadingState/PortalLoadingState.ts